import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const handleLanguageChange = (e) => {
        const newLang = e.target.value;
        if (i18n && typeof i18n.changeLanguage === 'function') {
            i18n.changeLanguage(newLang);
        } else {
            console.error('i18n instance or changeLanguage is not available');
        }
    };

    return (
        <select className="language-selector" onChange={handleLanguageChange} value={i18n.language}>
            <option value="en">English</option>
            <option value="it">Italiano</option>
            <option value="fr">Français</option>
            <option value="tr">Türkçe</option>
            <option value="ar">العربية</option>
            <option value="fa">فارسی</option>
            <option value="pl">Polski</option>
            <option value="et">Eesti</option>
            <option value="ro">Română</option>
            <option value="pt">Português</option>
        </select>
    );
};

export default LanguageSelector;
